import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { AuthContextProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { installApiGuard } from './utils/apiGuard';
import './tailwind.css';
import './index.scss';

// Must run before anything can issue a request, so no API call can slip past
// it and surface a raw JSON-parse error to the user.
installApiGuard();

const root = createRoot(document.getElementById('root'));

root.render(
	<React.StrictMode>
		<ThemeProvider>
			<AuthContextProvider>
				<App />
			</AuthContextProvider>
		</ThemeProvider>
	</React.StrictMode>
);